import { useGetUniversityInstancesQuery } from "@api/university";
import { ChevronRightIcon } from "@heroicons/react/16/solid";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { environment } from "../app/environment";

export function InstitutionHint() {
  const { t } = useTranslation("loginPage");
  const { data: universityInstances } = useGetUniversityInstancesQuery();
  const sortedInstances = useMemo(() => {
    return !universityInstances
      ? []
      : [...universityInstances].sort((a, b) =>
          a.fullName.localeCompare(b.fullName),
        );
  }, [universityInstances]);

  if (!environment.isOneTutorDomain && environment.name !== "development") {
    return null;
  }

  if (!universityInstances || universityInstances.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <div className="text-center text-base-content/70 text-sm">
        {t("notSeeingInstitution")}{" "}
        <div className="collapse">
          <input type="checkbox" />
          <div className="collapse-title inline p-0">
            <button
              type="button"
              className="text relative inline-flex animate-pulse items-center"
            >
              {t("useInstitutionDomain")}
              <ChevronRightIcon className={"ml-1 h-5 w-5"} />
            </button>
          </div>
          <div className="collapse-content p-0">
            <div className="mt-3 rounded-lg bg-base-200 p-3">
              <div className="mb-2 font-medium text-base-content text-sm">
                {t("availableInstitutionDomains")}
              </div>
              <div className="space-y-1">
                {sortedInstances.map((university) => (
                  <div
                    key={university.shortName}
                    className="flex items-center justify-between"
                  >
                    <span className="text-base-content/80 text-sm">
                      {university.fullName}
                    </span>
                    <a
                      href={university.instanceUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary text-xs hover:underline"
                    >
                      {university.instanceUrl.replace(/^https?:\/\//, "")}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
